{
    "Title": "Wachtrijen beheren",
    "ManageQueuesDescriptionTitle": "Beschrijving",
    "ManageQueuesCQConfigurationsTitle": "CQ-configuraties",
    "ManageQueuesResourceAccountsTitle": "Resource-accounts",
    "ManageQueuesMonitoringStatusTitle": "Monitoringstatus",
    "ManageQueueFiltersTitle": "Filters",
    "ManageQueueCallMonitoringHistoric": "Historisch",
    "ManageQueueCallMonitoringRealTime": "Real-time",
    "ManageQueueCallMonitoringRealTimeForced": "Real-time (gedwongen)",
    "ManageQueueCallMonitoringUnknown": "Onbekend",
    "ManageQueueCallCQConfigurationCompatible": "Verenigbaar",
    "ManageQueueCallCQConfigurationIncompatible": "Onverenigbaar",
    "ManageQueuesQueueFilterAll": "Alle wachtrijen",
    "ManageQueuesFilterCompatible": "Compatibele wachtrijen",
    "ManageQueuesFilterIncompatible": "Incompatibele wachtrijen",
    "ManageQueue_DisableEnableRealtime_Confirm": "Bevestigen",
    "ManageQueue_DisableEnableRealtime_Cancel": "Annuleren",
    "ManageQueue_MonitorAllMessage": "Weet u zeker dat u realtime monitoring voor alle wachtrijen wilt inschakelen?",
    "ManageQueue_UnmonitorAllMessage": "Weet u zeker dat u realtime monitoring voor alle wachtrijen wilt uitschakelen?",
    "ManageQueue_Loading_Monitoring_All": "Realtime monitoring voor alle wachtrijen inschakelen",
    "ManageQueue_Loading_Unmonitoring_All": "Realtime monitoring voor alle wachtrijen uitschakelen",
    "ManageQueue_Pending_Queue_Disabling": "Monitoring uitschakelen...",
    "ManageQueue_Pending_Queue_Enabling": "Monitoring inschakelen...",
    "ManageQueue_Disable_RT_Popper": "Realtime monitoring op alle wachtrijen uitschakelen",
    "ManageQueue_Enable_RT_Popper": "Realtime monitoring inschakelen voor alle wachtrijen",
    "ManageQueues_Not_Found_Error": "Er zijn geen wachtrijen gevonden die aan die zoekopdracht voldoen",
    "NAME": "ManageQueues"
}